import { ISharePointFolder } from "../../interfaces/ISharePointFolder";
import { ISiteInfo } from "../../interfaces/ISiteInfo";
import { ITeam } from "../../interfaces/services/ITeam";
import { getFolderPathsInfo } from "../../services/GraphService";
import { IDirectoryBuilder } from "../../interfaces/IDirectoryBuilder";
import { SharepointFolderLocationBuilder } from "./sharepointSearch/sharepointFolderLocationBuilder";
import { SharepointWorkingDirectoriesBuilder } from "./sharepointSearch/sharepointWorkingDirectoriesBuilder";

export class SearchedSharepointFoldersDirectoryBuilder implements IDirectoryBuilder {
  constructor(private sites: ISiteInfo[], private teams: ITeam[], private type: string, private isTeamsFolder: boolean, private siteUrl?: string) { }

  async getFolderDirectories(item: ISharePointFolder) {
    const folderPathBuilder = new SharepointFolderLocationBuilder(item.webUrl, this.isTeamsFolder, this.siteUrl);
    const paths = await folderPathBuilder.build(item.siteId);
    const drives = await getFolderPathsInfo(item.driveId, paths);

    const workingDirectoriesBuilder = new SharepointWorkingDirectoriesBuilder(
      folderPathBuilder,
      this.sites,
      this.teams,
      drives,
      item.siteId,
      item.driveId,
      this.type,
      this.isTeamsFolder
    );

    return await workingDirectoriesBuilder.build();
  };
}
